import { getStoreAddress } from "../services/mightyWifiApi";
import { SET_STORE_ADDRESS } from "./types";

export function setStoreAddress(storeAddresses) {
    return {
        type: SET_STORE_ADDRESS,
        storeAddresses
    };
}

export function getStoreAddresses() {
    return dispatch => {
        return getStoreAddress().then(res => {
            if (res.status) {
                console.log("getStoreAddresses",res);
                dispatch(setStoreAddress(res.storeAddresses));
            }
        });
    };
}







// WEBPACK FOOTER //
// ./src/modules/actions/storeAddressActions.js